export default {
  setUserProfile(state, value) {
    state.tgInviteLinkCpa = value.tgInviteLinkCpa || ''
    state.minAppURL = value.minAppURL || ''
  },
  setTgBtn(state, value) {
    state.tgBtn = value
  },
}
